import styled from '@emotion/styled';

import { border, boxShadow, colors } from '@datacamp/waffles-tokens';

// Partial port of Card from Waffles
// If options are missing, they'll need to be ported as well
// https://github.com/datacamp-engineering/design-system/tree/master/packages/stylesheets/card

/* eslint-disable import/prefer-default-export */
export const Container = styled.div`
  background-color: ${colors.white};
  border-radius: ${border.radius};
  box-shadow: ${props => (props.shadow ? props.shadow : boxShadow.md)};
  display: ${props => props.display && props.display};
  padding: ${props => (props.padding >= 0 ? `${props.padding}px` : '12px')};
  position: relative;

  &:active,
  &:focus,
  &:hover {
    box-shadow: ${props => props.interactive && boxShadow.xl};
    transform: ${props => props.interactive && 'translate(0, -4px)'};
  }
`;
